// Scroll Animation
const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
        }
    });
}
window.addEventListener("scroll", checkScroll);
checkScroll();



// Thumb Animation
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
    thumbItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height;
        const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
        }
    });
}
window.addEventListener("scroll", checkVisibility);
checkVisibility();



// Reveile Animation
function singleScrollReveal(className = ".reveal-group", visibleOffset = 150, delay = 300) {
    function runReveal() {
        $(className).each(function () {
            var $parent = $(this);
            var windowHeight = $(window).height();
            var elementTop = $parent.offset().top - $(window).scrollTop();

            if (elementTop < windowHeight - visibleOffset) {
                $parent.children().each(function (index) {
                    var $ele = $(this);
                    setTimeout(function () {
                        $ele.addClass("insight");
                    }, index * delay);
                });
            }
        });
    }
    $(window).on("scroll", runReveal);
    $(document).ready(runReveal);
}
singleScrollReveal();







$(document).ready(function () {
    function checkVisibility() {
        $('.fade-in-scroll').each(function () {
            var elementTop = $(this).offset().top;
            var viewportBottom = $(window).scrollTop() + $(window).height();
            if (elementTop < viewportBottom - 1) {
                $(this).addClass('is-show');
            }
        });
    }
    checkVisibility();
    $(window).on('scroll', function () {
        checkVisibility();
    });

});



// Header Sticky

function headerSticky() {
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    if (!header) return;
    window.addEventListener('scroll', function () {
        const currentScroll = window.scrollY;
        if (currentScroll > 60) header.classList.add('header__inner_hove-active');
        else header.classList.remove('header__inner_hove-active');
        if (currentScroll <= 60) {
            header.style.transform = 'translateY(0)';
        }
        else if (currentScroll < lastScrollTop) {
            header.style.transform = 'translateY(0)';
        }
        else {
            header.style.transform = 'translateY(-120%)';
        }
        lastScrollTop = currentScroll;
    });
}

headerSticky();






$(document).ready(function () {
    $('.cocktail-showcase__mobi-play, .cocktail-showcase__play-btn, .single-product__video-icon, .open-video-modal').on('click', function () {
        const videoSrc = $(this).attr('data-att');
        const $section = $(this).closest('section');
        const $modal = $section.find('.modal');
        $modal.find('video source').attr('src', videoSrc);
        const video = $modal.find('video')[0];
        video.load();
        video.play();
        $modal.addClass('active');
        $('body').addClass('modal-open');
    });
    $('.modal__close').on('click', function () {
        const $modal = $(this).closest('.modal');
        const video = $modal.find('video')[0];
        video.pause();
        video.currentTime = 0;
        $modal.removeClass('active');
        $('body').removeClass('modal-open');
    });
    $('.overlay').on('click', function () {
        $('.modal.active').each(function () {
            const video = $(this).find('video')[0];
            video.pause();
            video.currentTime = 0;
            $(this).removeClass('active');
        });
        $('body').removeClass('modal-open');
    });
});




$(document).ready(function () {
    $(".faq-questions__title").first().addClass("active");
    $(".faq-questions__content").first().show();
    $(".faq-questions__title").click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass("active");
            $(this).next(".faq-questions__content").slideUp();
        } else {
            $(".faq-questions__content").slideUp();
            $(".faq-questions__title").removeClass("active");
            $(this).addClass("active");
            $(this).next(".faq-questions__content").slideDown();
        }
    });
});



// single-product slider start

$('.single-product__big-img').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.single-product__small-imgs',
});
$('.single-product__small-imgs').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.single-product__big-img',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        },
    ]
});

// single-product slider end





document.addEventListener('DOMContentLoaded', function () {
  const addToCart = document.querySelector('.single-product__addtocart');
  const stickyBundle = document.querySelector('.recommended-bundle__inner');

  if (!addToCart || !stickyBundle) return;

  stickyBundle.style.display = 'none';

  function toggleStickyBundle() {
    const rect = addToCart.getBoundingClientRect();

    if (rect.bottom < 0) {
      stickyBundle.style.display = 'block';
    } else {
      stickyBundle.style.display = 'none';
    }
  }

  toggleStickyBundle();

  window.addEventListener('scroll', toggleStickyBundle);
  window.addEventListener('resize', toggleStickyBundle);
});




if ($(window).width() < 991) {
  $(".single-product__story-items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});
}



if ($('.single-product__reviews').length) {
  $('.single-product__reviews').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    pauseOnHover: false,
    pauseOnFocus: false,
    adaptiveHeight: true
  });
}